export default "__VITE_ASSET__BWQlDONY__"